import {
  newVisionConverter as _newVisionConverter,
  visionConverter as _visionConverter,
} from '@griply/services';
import { FirestoreDataConverter } from 'firebase/firestore';
import { Vision } from 'shared/types/vision';

export const visionConverter =
  _visionConverter as unknown as FirestoreDataConverter<Vision>;

export const newVisionConverter = _newVisionConverter;
